var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closePicker,
          expression: "closePicker"
        }
      ],
      staticClass: "app-date-picker"
    },
    [
      _vm.$slots.default
        ? _c(
            "div",
            { staticClass: "app-date-picker__label" },
            [
              _vm.$attrs.required
                ? _c("span", { staticClass: "require-mark" }, [_vm._v("*")])
                : _vm._e(),
              _vm._v(" "),
              _vm._t("default")
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "app-date-picker__wrapper" },
        [
          _c(
            "div",
            {
              staticClass: "app-date-picker__toggle",
              class: {
                "app-date-picker__toggle--disabled": _vm.$attrs.disabled,
                "app-date-picker__toggle--error": _vm.hasError
              },
              on: {
                click: function($event) {
                  _vm.open = !_vm.open
                }
              }
            },
            [
              _c("AppIcon", {
                staticClass: "app-date-picker__icon",
                attrs: { "icon-name": "calendar", "icon-color": "#778395" }
              }),
              _vm._v(" "),
              _c(
                "input",
                _vm._b(
                  {
                    staticClass: "app-date-picker__input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.displayValue },
                    on: {
                      invalid: _vm.setInvalidMessage,
                      keydown: function($event) {
                        $event.preventDefault()
                      },
                      keypress: function($event) {
                        $event.preventDefault()
                      },
                      paste: function($event) {
                        $event.preventDefault()
                      },
                      input: function($event) {
                        $event.preventDefault()
                      }
                    }
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.open
            ? _c("AppCalendar", {
                staticClass: "app-date-picker__calendar",
                class: {
                  "app-date-picker__calendar--top": _vm.getPositionReference()
                    .isTop,
                  "app-date-picker__calendar--right": _vm.getPositionReference()
                    .isRight
                },
                attrs: {
                  value: _vm.value,
                  min: _vm.min,
                  max: _vm.max,
                  dotDates: _vm.dotDates
                },
                on: {
                  input: function($event) {
                    return _vm.selectDate($event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasError
        ? _c("p", { staticClass: "app-date-picker__error" }, [
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.invalidMessage || _vm.error) + "\n\t\t"
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f8371c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8371c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app-components/AppDatePicker.vue
// module id = null
// module chunks = 